import React from "react";
import { useContent } from "@/context/ContentProvider";
import { Reveal } from "@/components/Reveal";

const LegalPage = ({ type }) => {
  const { t } = useContent();
  const title = type === "privacy" ? t("legal.privacy_title", "Política de Privacidad") : t("legal.terms_title", "Términos y Condiciones");
  const body = type === "privacy" ? t("legal.privacy", "") : t("legal.terms", "");

  return (
    <div className="min-h-screen bg-[#faf7f2] pb-24 pt-[120px]" data-testid={`legal-${type}`}>
      <div className="mx-auto max-w-3xl px-4 sm:px-6">
        <Reveal>
          <h1 className="font-serif-d text-5xl font-semibold text-[#4b3a2f]">{title}</h1>
          <div className="mt-8 space-y-4 rounded-3xl border border-[#e8ded4] bg-white p-8 sm:p-10">
            {body.split("\n").filter(Boolean).map((p, i) => (
              <p key={i} className="leading-relaxed text-[#4b3a2f]/90">{p}</p>
            ))}
            {!body && <p className="text-[#6b5b52]">Contenido en preparación.</p>}
          </div>
        </Reveal>
      </div>
    </div>
  );
};

export default LegalPage;
